import { ChatChannelStatsResponse } from '@projects/shared/src/app/features/chat/interfaces/dashboard/ChatChannelStatsResponse';

export const generateSeries = (data: Array<ChatChannelStatsResponse>) =>
  [
    {
      type: 'column',
      showInLegend: false,
      pointWidth: 25,
      data: data.map((d) => ({ name: d.Name, y: +d.Count })),
    },
  ] as Highcharts.SeriesOptionsType[];

export const highchartChatChannelTrackConfig = (data: Array<ChatChannelStatsResponse>) => {
  const maxCount = Math.max(10, ...data.map((o) => +o.Count + 5));

  let config: Highcharts.Options = {
    chart: {
      type: 'column',
    },
    title: {
      text: undefined,
    },
    xAxis: {
      categories: data.map((d: ChatChannelStatsResponse) => d.Name),
      lineWidth: 0,
      labels: {
        // align: 'left',
        // x: -32,
        // y: 20,
        style: {
          // color: '#344054',
          fontSize: '14px',
          textOverflow: 'ellipsis',
        },
      },
    },
    yAxis: {
      title: {
        text: undefined,
      },
      gridLineDashStyle: 'LongDash',
      min: 1,
      max: maxCount,
      labels: {
        style: {
          // color: '#475467',
        },
      },
    },
    plotOptions: {
      bar: {
        pointWidth: 14,
        zones: [
          {
            value: Math.max(...data.map((d) => +d.Count)), // condition
            color: '#E5E5F1', // if true.
          },
          {
            color: '#344054', // else
          },
        ],
      },
    },
    tooltip: {
      formatter: function () {
        return [this.x + ': ' + this.y];
      },
    },
    credits: {
      enabled: false,
    },
    series: generateSeries(data),
  };
  return config;
};
